import { stActionTypes } from '@Actions/stActions';

const STReducer = (state = { }, action) => {
  switch (action.type) {
  case stActionTypes.CREATE_ST.LOADING: {
    const { createStLoading } = action;
    return {
      ...state,
      createStLoading,
    };
  }
  case stActionTypes.UPDATE_ST.LOADING: {
    const { updateStLoading } = action;
    return {
      ...state,
      updateStLoading,
    };
  }
  case stActionTypes.UPDATE_ST_STATUS.LOADING: {
    const { updateStStatusLoading } = action;
    return {
      ...state,
      updateStStatusLoading,
    };
  }
  case stActionTypes.GET_ST.LOADING: {
    const { getStLoading } = action;
    return {
      ...state,
      getStLoading,
    };
  }
  case stActionTypes.GET_ST.SUCCESS: {
    const { sts } = action;
    return {
      ...state,
      stockTransfer: sts,
    };
  }
  case stActionTypes.GET_ST_BY_ID.LOADING: {
    const { getStByIdLoading } = action;
    return {
      ...state,
      getStByIdLoading,
    };
  }
  case stActionTypes.GET_ST_BY_ID.SUCCESS: {
    const { selectedSt } = action;
    return {
      ...state,
      selectedSt,
    };
  }
  case stActionTypes.DELETE_ST.LOADING: {
    const { deleteStLoading } = action;
    return {
      ...state,
      deleteStLoading,
    };
  }
  case stActionTypes.ST_SHORT_CLOSE.SUCCESS: {
    const { shortClose } = action;
    return {
      ...state,
      shortClose,
    };
  }
  case stActionTypes.ST_SHORT_CLOSE.LOADING: {
    const { shortCloseStLoading } = action;
    return {
      ...state,
      shortCloseStLoading,
    };
  }
  case stActionTypes.UPDATE_ST_WORKFLOW_STEP.LOADING: {
    const { updateSTWorkflowStepLoading } = action;
    return {
      ...state,
      updateSTWorkflowStepLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default STReducer;
